import { getYandexPaymentStatus } from '../../../../shared/services/billingPayments';
import { adAnalyticsCategory } from '../../scripts/services/analytics.service';

export default [
  '$rootScope', 'apiService', 'userService', 'placingTermsApi', 'config', 'httpApi', 'logger',
  function ($rootScope, apiService, userService, placingTermsApi, config, httpApi, logger) {
    let state; // статусы платежа: undefined | 'pending' | 'succeeded' | 'canceled'
    let clientOrderId;
    let checkInterval;
    let failTimeout;
    let isPaymentProcessed;
    let paymentSum;

    const isYandexKassaV2Enabled = config.get('isYandexKassaV2.Enabled');

    const clearTimers = () => {
      clearInterval(checkInterval);
      clearTimeout(failTimeout);
    };

    const checkPaymentLegacy = () => {
      apiService.getYandexPaymentStatus(clientOrderId)
        .then((paymentProcessed) => {
          if (paymentProcessed === true) {
            updateBalance();

            state = 'succeeded';

            clearTimers();

            ca('eventSite', {
              name: 'oldevent',
              category: adAnalyticsCategory,
              action: 'success_pay',
              label: String(paymentSum),
            });
          }
        }).catch(() => {
          ca('eventSite', {
            name: 'oldevent',
            category: adAnalyticsCategory,
            action: 'recharge_balance_popup',
            label: 'status_error',
          });
        });
    };

    const checkPayment = () => {
      if (!isYandexKassaV2Enabled) {
        // Выпиливаем в https://jira.cian.tech/browse/CD-67314
        checkPaymentLegacy();

        return;
      }

      const parameters = { paymentId: clientOrderId };

      getYandexPaymentStatus({ httpApi, logger, parameters })
        .then(({ status }) => {
          state = status;

          if (status !== 'pending') {
            updateBalance();

            clearTimers();

            ca('eventSite', {
              name: 'oldevent',
              category: adAnalyticsCategory,
              action: 'success_pay',
              label: paymentSum,
            });
          }
        }).catch(() => {
          ca('eventSite', {
            name: 'oldevent',
            category: adAnalyticsCategory,
            action: 'recharge_balance_popup',
            label: 'status_error',
          });
        });
    };

    const runCheckPaymentState = (id) => {
      if (!isPaymentProcessed) {
        return;
      }

      clearTimers();

      state = 'pending';

      if (id) {
        clientOrderId = id;
      }

      checkInterval = setInterval(checkPayment, 3000); // 3 секунды

      failTimeout = setTimeout(() => {
        state = 'canceled';

        ca('eventSite', {
          name: 'oldevent',
          category: adAnalyticsCategory,
          action: 'recharge_balance_popup',
          label: 'timeout',
        });

        clearTimers();
      }, 900000); // 15 минут

      checkPayment();
    };

    const updateBalance = () => {
      apiService.getUserBalance()
        .then((data) => {
          if (data.totalBalance !== undefined) {
            const isNotEnoughMoney = data.totalBalance < placingTermsApi.getTotalPriceAmount();

            userService.setBalance(data.totalBalance);
            placingTermsApi.setNotEnoughMoney(isNotEnoughMoney);
          }
        });
    };

    const getState = () => state;

    const resetState = () => {
      isPaymentProcessed = undefined;
    }

    // Данный переключатель состояния оплаты внедрён для исключения ситуации когда модалка с фреймом оплаты открывается,
    // но оплата не производится. При этом запускается ненужный механизм проверки оплаченности транзакции, которой не было.
    const setPaymentProcessed = (state) => {
      // Стартовое значение undefined.
      switch (true) {
        case typeof state !== 'undefined':
          isPaymentProcessed = state;
        break;

        case typeof isPaymentProcessed === 'undefined':
          // При первой загрузке устанавливаем false.
          isPaymentProcessed = false;
          // Это удобно, так как в runCheckPaymentState (см. выше) мы проверяем переменную на истинность.
          // Это логично, так как первый шаг — это ввод данных платёжной карты. Без них нет транзакции.
        break;

        case isPaymentProcessed === false:
          // На следующем шаге мы устанавливаем true.
          isPaymentProcessed = true;
          // Транзакция началась, есть смысл проверять.
        break;
      }
    }

    const setPaymentSum = (value) => {
      paymentSum = value;
    }

    const getPaymentSum = () => paymentSum;

    $rootScope.$on('terms.changed', () => {
      resetState();
    });

    return {
      runCheckPaymentState,
      getState,
      resetState,
      setPaymentProcessed,
      getPaymentSum,
      setPaymentSum,
    };
  },
];
